/* src/components/change-user-modal/change-user-modal.component.scss */
:host {
  display: block;
  height: var(--vwui-modal--max-height);
}
.notification {
  display: inline-flex;
  align-items: center;
  vertical-align: top;
  color: var(--vwui-color-info);
  font-weight: var(--vwui-font-weight-semibold);
  height: var(--vwui--spacing--xxl);
  padding: 0 var(--vwui--spacing--md);
}
.notification vwui-icon {
  margin-right: var(--vwui--spacing--sm);
}
/*# sourceMappingURL=change-user-modal.component-DE7734T3.css.map */
